
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Ref, Prop, Watch } from "vue-property-decorator";
    import { VForm } from "@/vForm";
    import Utils from "@/utilities/Utils";
    import FileUpload from "@/vue/components/FileUpload.vue";
    import HtmlEditor from "@/vue/components/HtmlEditor.vue";
    import { ResourceAndTextOptions } from "@/model/pagePartOptions/ResourceAndTextOptions";
    import { Resource } from "@/model/Resource";
    import { ResourceAndTextLayout, ResourceContentType } from "@/model/Enums";

    @Component({ components: { FileUpload, HtmlEditor } })
    export default class ResourceAndTextPartEdit extends Vue {

        mounted(): void {
            this.saveLayoutType = this.pagePartOptions.layoutType;
        }

        @Ref("editForm") private readonly editForm!: VForm;

        @Prop({ required: true })
        pagePartOptions!: ResourceAndTextOptions;

        // so we can use in template
        resourceAndTextLayout: any = ResourceAndTextLayout;
        resourceContentType: any = ResourceContentType;

        // rmember original layoutType in case we automatically change it (no html) but want to change back
        saveLayoutType: ResourceAndTextLayout = ResourceAndTextLayout.Default;

        onUploaded(resource: Resource): void {
            // set the content type automatically?
            const contentType = resource?.httpContentType;
            if(contentType.startsWith("image/")) this.pagePartOptions.contentType = ResourceContentType.Image;
            else if(contentType.startsWith("audio/")) this.pagePartOptions.contentType = ResourceContentType.Audio;
            else if(contentType.startsWith("video/")) this.pagePartOptions.contentType = ResourceContentType.Video;
        }

        @Watch("pagePartOptions.html")
        onHtmlchanged(): void {
            const isEmpty = Utils.isEmptyOrWhitespace(this.pagePartOptions.html) || this.pagePartOptions.html === "<p></p>";
            //console.log("HTML=", this.pagePartOptions.html);
            if(isEmpty && this.pagePartOptions.layoutType !== ResourceAndTextLayout.NoText) {
                this.saveLayoutType = this.pagePartOptions.layoutType;
                this.pagePartOptions.layoutType = ResourceAndTextLayout.NoText;
            }
            else if(!isEmpty && this.pagePartOptions.layoutType === ResourceAndTextLayout.NoText) {
                if(this.saveLayoutType === ResourceAndTextLayout.Default) this.saveLayoutType = ResourceAndTextLayout.TextOnLeft;
                this.pagePartOptions.layoutType = this.saveLayoutType;
            }
        }

        @Watch("pagePartOptions.layoutType") onLayoutTypechanged(): void {
            // don't let percent go full width if it's a two-col layout
            if((this.pagePartOptions.layoutType === ResourceAndTextLayout.TextOnLeft
            || this.pagePartOptions.layoutType === ResourceAndTextLayout.TextOnRight)
            && this.pagePartOptions.widthPercent > 90) {
                this.pagePartOptions.widthPercent = 50;
            }
        }

        @Watch("pagePartOptions.widthPercent") onWidthPercentchanged(): void {
//console.log("CHANGING WIDTH...");
            // don't let percent go full width if it's a two-col layout
            if((this.pagePartOptions.layoutType === ResourceAndTextLayout.TextOnLeft
            || this.pagePartOptions.layoutType === ResourceAndTextLayout.TextOnRight)
            && this.pagePartOptions.widthPercent > 90) {
                setTimeout(() => {
                    this.pagePartOptions.widthPercent = 90;
                }, 300);
            }

            if(this.pagePartOptions.widthPercent < 10) {
                setTimeout(() => {
                    this.pagePartOptions.widthPercent = 10;
                }, 300);
            }
        }

        // reformat vimeo ID from pasted sh*te
        @Watch("pagePartOptions.vimeoID") onVimeoIdChanged(): void {
            let text = this.pagePartOptions.vimeoID;
            if(!text) return;
            // could probably do this with less code using regex, but y'know, regex...
            if(text.startsWith("https://vimeo.com/")) {
                text = text.substring(18);
            }
            // no - not going to support entering embed code now...
            // if(text.startsWith("<iframe")) {
            //     const uPos = text.indexOf("/video/");
            //     if(uPos > -1) text = text.substring(uPos + 7);
            //     const dPos = text.indexOf('"');
            //     if(dPos > -1) text = text.substring(0, dPos);
            // }
            const qPos = text.indexOf("?");
            this.pagePartOptions.vimeoID = qPos === -1
                ? text
                : text.substring(0, qPos);
        }

        get canAutoPlay(): boolean {
            return this.pagePartOptions.contentType === ResourceContentType.Video
                || this.pagePartOptions.contentType === ResourceContentType.Vimeo
                || this.pagePartOptions.contentType === ResourceContentType.Wistia
                || this.pagePartOptions.contentType === ResourceContentType.Audio;
        }

        get isImage(): boolean {
            return this.pagePartOptions.contentType === ResourceContentType.Image;
        }

        get isVimeo(): boolean {
            return this.pagePartOptions.contentType === ResourceContentType.Vimeo;
        }

        get isWistia(): boolean {
            return this.pagePartOptions.contentType === ResourceContentType.Wistia;
        }

        get isMomento(): boolean {
            return this.pagePartOptions.contentType === ResourceContentType.Momento;
        }

        validate(): boolean {
            return this.editForm.validate();
        }

    }
